import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import Profile from '../../components/profile';
import ButtonLogReg from '../../components/ButtonLogReg';
import Notification from '../../components/Notification';
import Trolly from '../../components/Trolly';
import { useCookies } from 'react-cookie';
import "../../css/detailSearch.css"
import LoadingScreen from '../../components/LoadingScreen';
import Alert from '../../components/Alert';

export default function DetailSearch() {
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [alertActive, setAlertActive] = useState(true);
    const [alert, setAlert] = useState({});
    const [product, setProduct] = useState({});
    const [seller, setSeller] = useState({});
    const [cookies, setCookie] = useCookies(['accessToken']);
    const [message, setMessage] = useState(' ')
    const [user, setUser] = React.useState({});

    const activateAlert = () => {
        setAlertActive(true);
        setTimeout(() => { setAlertActive(false); }, 3000);
    };

    let [count, setCount] = useState(1);
    function incrementCount() {
        count = count + 1;
        setCount(count);
    }
    function decrementCount() {
        count = count - 1;
        if (count < 1) {
            count += 1
        }
        setCount(count);
    }

    useEffect(() => {
        const getProductData = async () => {
            try {
                const url = 'https://w-shop-backend.vercel.app/api/products/' + id;
                const response = await fetch(url, {
                    method: 'GET'
                });
                const body = await response.json();
                if (body.status !== 'success') {
                    throw new Error(body.message);
                }
                setProduct(body.data);
                setSeller(body.data.seller)
            } catch (error) {
                setProduct({});
            }
        }
        getProductData();
    }, [id])

    // const validateLocated = () => {
    //     if (!user.provinces && !user.address) {
    //         setAlert({
    //             type: "danger",
    //             message: "Lengkapi lokasi toko",
    //         });
    //         activateAlert();
    //     } else {
    //         navigate('/sellerProduct/add')
    //     }
    // }

    const handleAddWishlist = async () => {
        try {
            if (!user.provinces && !user.address) {
                setAlert({
                    type: "danger",
                    message: "Lengkapi lokasi anda",
                });
                activateAlert();
            } else {
                if (user.role !== 'buyer') {
                    setAlert({
                        type: 'danger',
                        message: 'Error: Harap Login Dahulu',
                    })
                    activateAlert();
                    return
                }
                setIsLoading(true);
                const id = product.id
                const url = `https://w-shop-backend.vercel.app/api/products/${id}/wishlist`;
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-type': 'application/json',
                        'Authorization': 'Bearer ' + cookies.accessToken,
                    },
                    body: JSON.stringify({ amount: parseInt(count), message: message }),
                });
                const body = await response.json();
                if (body.status !== 'success') {
                    throw new Error(body.message,);
                }
                const event = {
                    type: 'alert',
                    alert: {
                        type: 'success',
                        message: 'Produk ditambahkan ke keranjang',
                    }
                };
                setCookie('event', event, { path: '/' });
                setAlert(event.alert)
                activateAlert()
                setTimeout(() => { window.location.reload() }, 100);
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false);
            setAlert({
                type: 'danger',
                message: 'Error: ' + error.message,
            })
            activateAlert();
        }
    }

    let logReg
    let mB
    let notification
    let trolly
    if (user.role === 'buyer') {
        logReg = <Profile userData={user} />
        mB = ''
        trolly = <Trolly />
        notification = <Notification />
    } else {
        logReg = <ButtonLogReg />
        mB = <a href="/sellerLogin" className="navbar-top">Mulai Berjualan  |</a>
    }

    const rupiah = (number) => {
        return new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
        }).format(number);
    };

    return (
        <div >
            <LoadingScreen active={isLoading} />
            <Alert active={alertActive} type={alert.type} message={alert.message} />
            <Navbar logReg={logReg} mb={mB} notification={notification} trolly={trolly} userData={setUser} />
            <div className=' py-5' style={{ backgroundColor: "#F6F6F6" }}>
                <div className='container'>
                    <div className='detail1 p-4 row '>
                        <div className="col-12 col-lg-5">
                            <img alt="" src={product.imgUrl} style={{ width: "100%", height: "100%" }} />
                        </div>
                        <div className='col-12 col-lg-7 ps-5'>
                            <h1 className='titleDetail py-4'>{product.product}</h1>
                            <h1 className='priceDetail p-3 my-4'>{rupiah(product.price)}</h1>
                            <div className='row'>
                                <p className='col-4 pt-1' style={{ width: 80 }}>Kuantitas</p>
                                <div className='col-4' style={{ width: 160 }}>
                                    <div className='d-flex'>
                                        <button className='amount btn' onClick={decrementCount}>-</button>
                                        <input className='amount text-center btn' style={{ width: 50 }} type='number' z value={count} />
                                        <button className='amount btn' onClick={incrementCount}>+</button>
                                    </div>
                                </div>
                                <p className='col-4 pt-1'>{product.stock} pcs</p>
                            </div>
                            <input type='text' placeholder='Pesan' className='w-100 border-0 border-bottom mt-5' style={{ outline: "0", border: "dashed" }} onChange={(e) => (setMessage(e.target.value))} />
                            <button className='btn p-3 btn-primary mKeranjang my-3' onClick={handleAddWishlist} ><img alt='' src='/img/keranjang.png' /> Masukan Keranjang</button>
                        </div>
                    </div>
                    <div className='detail1 p-4 mt-5 row'>
                        <div className='col d-flex'>
                            <img alt='' src={seller.imgUrl} style={{ width: 51, height: 50 }} />
                            <div>
                                <h5 className='spDetail  ms-3'>{seller.shopName}</h5>
                                <h6 className=' ms-3'>{seller.provinces}</h6>
                            </div>
                        </div>
                        <div className='col'>
                            <a href={`/shopPage/${seller.id}`} className='kujo ms-auto p-2 text-center d-flex justify-content-center'><p className=' mt-1 me-1'>Kunjungi Toko</p> <img alt='' src='/img/blueToko.png' /></a>
                        </div>
                    </div>
                    <div className='detail1 p-4 mt-5 row'>
                        <div className='titDesc p-3 mb-5'>
                            Deskripsi
                        </div>
                        <div className='descDet text' style={{ textAlign: "justify" }}>
                            {product.description}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
